"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./ProgressRadial.scss");

var _progressRadial = _interopRequireDefault(require("@ruter-ds/rds-tokens/dist/json/progress-radial.json"));

var _excluded = ["value", "min", "max", "skin", "size", "isIndeterminate", "className", "variant", "showPercentage"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The current value of the progress*/
  value: _propTypes.number,
  min: _propTypes.number,
  max: _propTypes.number,

  /** Pick your preferred skin */
  skin: (0, _propTypes.oneOf)(['red', 'dark', 'neutral', 'light', 'inherit']),

  /** Choose size */
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),

  /** Show or hide percentage */
  showPercentage: _propTypes.bool,

  /** */
  isIndeterminate: _propTypes.bool,

  /** Choose between rounded or square caps */
  variant: (0, _propTypes.oneOf)(['rounded', 'square']),

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  variant: 'rounded',
  size: 'medium',
  skin: 'red',
  value: 0,
  min: 0,
  max: 100,
  showPercentage: false
};
/**
 * A progress radial displays status of a determinate or indeterminate process.
 * @visibleName Progress Radial
 * */

var ProgressRadial = function ProgressRadial(_ref) {
  var value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      skin = _ref.skin,
      size = _ref.size,
      isIndeterminate = _ref.isIndeterminate,
      className = _ref.className,
      variant = _ref.variant,
      showPercentage = _ref.showPercentage,
      rest = _objectWithoutProperties(_ref, _excluded);

  var pixelSize, strokeWidth; // Change size into pixel size and change the stroke based on size

  switch (size) {
    case 'small':
      pixelSize = 24;
      strokeWidth = _progressRadial.default.SIZE_PATH_PROGRESS_RADIAL_SMALL;
      break;

    case 'medium':
      pixelSize = 44;
      strokeWidth = _progressRadial.default.SIZE_PATH_PROGRESS_RADIAL_MEDIUM;
      break;

    case 'large':
      pixelSize = 88;
      strokeWidth = _progressRadial.default.SIZE_PATH_PROGRESS_RADIAL_LARGE;
      break;

    default:
      pixelSize = 44;
      strokeWidth = 4;
  }

  var center = pixelSize / 2;
  var radius = center - strokeWidth / 2;
  var circumference = Math.PI * (radius * 2);

  var getPercentage = function getPercentage() {
    return Math.round((value - min) / (max - min) * 100 * 10) / 10;
  };

  var getDashOffset = function getDashOffset(value) {
    if (value < min) {
      value = min;
    }

    if (value > max) {
      value = max;
    }

    return (max - value) / (max - min) * circumference;
  };

  var _useState = (0, _react.useState)(getDashOffset(value)),
      _useState2 = _slicedToArray(_useState, 2),
      dashOffset = _useState2[0],
      setDashOffset = _useState2[1];

  (0, _react.useEffect)(function () {
    setDashOffset(getDashOffset(value));
  });
  var componentClassNames = (0, _classnames.default)('rds-progress-radial', {
    'rds-progress-radial--is-indeterminate': isIndeterminate,
    'rds-progress-radial--size-small': size === 'small',
    'rds-progress-radial--size-medium': size === 'medium',
    'rds-progress-radial--size-large': size === 'large',
    'rds-progress-radial--skin-red': skin === 'red',
    'rds-progress-radial--skin-dark': skin === 'dark',
    'rds-progress-radial--skin-neutral': skin === 'neutral',
    'rds-progress-radial--skin-light': skin === 'light',
    'rds-progress-radial--skin-inherit': skin === 'inherit',
    'rds-progress-radial--round-caps': variant === 'rounded' && value >= 1 || variant === 'rounded' && isIndeterminate
  }, className);

  if (isIndeterminate) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: componentClassNames,
      style: {
        width: "".concat(pixelSize, "px"),
        height: "".concat(pixelSize, "px")
      }
    }, /*#__PURE__*/_react.default.createElement("svg", _extends({
      width: pixelSize,
      height: pixelSize,
      viewBox: "0 0 ".concat(pixelSize, " ").concat(pixelSize),
      className: 'rds-progress-radial__svg',
      role: "progressbar"
    }, rest), /*#__PURE__*/_react.default.createElement("circle", {
      cx: center,
      cy: center,
      r: radius,
      strokeWidth: strokeWidth
    }), /*#__PURE__*/_react.default.createElement("circle", {
      className: "rds-progress-radial__path",
      cx: center,
      cy: center,
      r: radius,
      stroke: "currentColor",
      strokeWidth: strokeWidth
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: componentClassNames,
      style: {
        width: "".concat(pixelSize, "px"),
        height: "".concat(pixelSize, "px")
      }
    }, /*#__PURE__*/_react.default.createElement("svg", _extends({
      width: pixelSize,
      height: pixelSize,
      viewBox: "0 0 ".concat(pixelSize, " ").concat(pixelSize),
      className: 'rds-progress-radial__svg',
      role: "progressbar",
      "aria-valuenow": "".concat(getPercentage(), "%"),
      "aria-valuemin": min,
      "aria-valuemax": max
    }, rest), /*#__PURE__*/_react.default.createElement("circle", {
      cx: center,
      cy: center,
      r: radius,
      strokeWidth: strokeWidth
    }), /*#__PURE__*/_react.default.createElement("circle", {
      className: "rds-progress-radial__path",
      cx: center,
      cy: center,
      r: radius,
      stroke: "currentColor",
      strokeWidth: strokeWidth,
      transform: variant === 'rounded' ? "rotate(-".concat(90 - 90 * (strokeWidth / circumference), " ").concat(center, " ").concat(center, ")") : "rotate(-90 ".concat(center, " ").concat(center, ")"),
      strokeDasharray: circumference,
      strokeDashoffset: dashOffset
    }), showPercentage && size === 'large' && /*#__PURE__*/_react.default.createElement("text", {
      className: "rds-progress-radial__percentage",
      x: "50%",
      y: "50%",
      textAnchor: "middle",
      alignmentBaseline: "middle",
      dy: "0.2em"
    }, "".concat(getPercentage(), "%"))));
  }
};

ProgressRadial.propTypes = propTypes;
ProgressRadial.defaultProps = defaultProps;
var _default = ProgressRadial;
exports.default = _default;